<app-admin-list-page [title]="'News' | translate">

  <a slot="actions" class="btn btn-primary" routerLink="/admin/externalpage/Blog">
    {{'Add new' | translate}}
  </a>

  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
